import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocumentTypeCodeDto, DocumentTypeDto, FiscalFileLocationDto, SecurityClassificationDto } from '@cradua/data';
import { TooltipPosition } from "@angular/material/tooltip";
import { FormControl } from "@angular/forms";
import * as XLSX from "xlsx";
type AOA = any[][];

interface IExcelModel {
  doc: any,
  documentTypes: DocumentTypeDto[],
  documentTypeCodes: DocumentTypeCodeDto[],
  securityClassifications: SecurityClassificationDto[],
  fileLocations: FiscalFileLocationDto[],
}

@Component({
  selector: 'cradua-excel-document-upload-view',
  templateUrl: './excel-document-upload-view.component.html',
  styleUrls: ['./excel-document-upload-view.component.scss']
})
export class ExcelDocumentUploadViewComponent implements OnInit {

  fileName = "SheetJS.xlsx";
  isLoading = false;
  data: any;
  documents: any

  positionOptions: TooltipPosition[] = [
    "after",
    "before",
    "above",
    "below",
    "left",
    "right",
  ];
  position = new FormControl(this.positionOptions[0]);

  constructor(
    public dialogRef: MatDialogRef<ExcelDocumentUploadViewComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: IExcelModel,
  ) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.onFileChange(this.modalData.doc);
  }



  onFileChange(ev) {
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      /* grab first sheet */
      const wsname: string = workBook.SheetNames[0];
      const ws: XLSX.WorkSheet = workBook.Sheets[wsname];

      /* save data */
      this.data = <AOA>XLSX.utils.sheet_to_json(ws, { header: 1 });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});

      this.documents = jsonData.Sheet1;

      const dataString = JSON.stringify(jsonData);
      // document.getElementById('output').innerHTML = dataString.slice(0, 300).concat("...");
      // console.log(jsonData.Sheet1);
      // this.setDownload(dataString);
      this.isLoading = false;
    };
    reader.readAsBinaryString(file);

  }

  onClose() {
    this.dialogRef.close()
  }

  onSubmit() {
    this.dialogRef.close(this.documents);
  }


  checkDocumentType(value: string) {
    if (value) {
      const foundDocumentType = this.modalData.documentTypes.find(
        (docType) =>
        docType.DocumentTypeName &&
        docType.DocumentTypeName.trim().toLowerCase() ===
            value.trim().toLowerCase(),
      );
      return foundDocumentType ? true : false;
    } else {
      return false;
    }
  }

  checkDocumentTypeCode(value: string) {
    if (value) {
      const foundDocumentTypeCode = this.modalData.documentTypeCodes.find(
        (docTypeCode) =>
        docTypeCode.DocumentTypeCodeName &&
        docTypeCode.DocumentTypeCodeName.trim().toLowerCase() ===
            value.trim().toLowerCase(),
      );
      return foundDocumentTypeCode ? true : false;
    } else {
      return false;
    }
  }

  checkFileLocation(value: string) {
    if (value) {
      const foundFileLocation = this.modalData.fileLocations.find(
        (fileLocation) =>
        fileLocation.FileLocationName &&
        fileLocation.FileLocationName.trim().toLowerCase() ===
            value.trim().toLowerCase(),
      );

      return foundFileLocation ? true : false;
    } else {
      return false;
    }
  }


  checkSecurity(value: string) {
    if (value) {
      const foundSecurityClassification = this.modalData.securityClassifications.find(
        (securityClassification) =>
        securityClassification.SecurityClassificationName &&
        securityClassification.SecurityClassificationName.trim().toLowerCase() ===
            value.trim().toLowerCase(),
      );

      return foundSecurityClassification ? true : false;
    } else {
      return false;
    }
  }


  checkReferences(value: any, header: string) {
    // console.log('session ', value, header);
    switch (header && header.toLowerCase()) {
      case 'documenttype':
        return this.checkDocumentType(value);
      case 'documenttypecode':
        return this.checkDocumentTypeCode(value);
      case 'filelocation':
        return this.checkFileLocation(value);
      case 'security':
        return this.checkSecurity(value);
      default:
        return true;
    }
  }

}
